import React from "react";
import InternalLoadLink from "../components/Library/InternalLoadLink";
import { ENTITY_TYPE } from "../config/constants";
import { isInternalURL } from "./utils";

export const entityToHTML = (story, styles) => (entity, originalText) => {
  if (entity.type.toLowerCase() === ENTITY_TYPE.LINK) {
    const matches = isInternalURL(entity.data.url);
    if (matches && matches.length > 1) {
      return (
        <InternalLoadLink
          name={originalText}
          href={entity.data.url}
          identifier={`${matches[1]}-${story.id}`}
          className={styles.link}/>
      );
    }
    return <a href={entity.data.url} className={styles.link}/>;
  }
  return originalText;
};



// WEBPACK FOOTER //
// ./src/utils/entityToHTML.js